export const drawerWidth = 260
export const shortDrawerWidth = 80
export const Timezones = [
  {
    value: 'gst',
    title: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London',
  },
  {
    value: 'pst',
    title: '(UTC+05:00) Islamabad, Karachi',
  },
]

export const DefaultChartTypes = ['Bar', 'Pie', 'Column']

export const ChartValues = ['Percent', 'Absolute']

export const VoteNowMessagePositions = ['Top', 'Bottom']

export const BulletFormats = ['Alpha', 'Numeric']

export const VoteNowMessageBgColors = [
  'Light Glass',
  'Dark Glass',
  'Solid Black',
  'Solid White',
  'Transparent',
]

export const ChartOptionColors = [
  '#008ee4',
  '#EE8800',
  '#6baa01',
  '#D5CA01',
  '#CF0000',
  '#9b59b6',
  '#FF66CC',
  '#336699',
  '#CC3300',
  '#19D1A3',
]

export const FontColor = '#FFFFD700'

export const ShowDecimalPlacesTooltip =
  'Specify a number from 0 to 10 of decimal places you want the audience to see on their devices. If you are using weighted voting, make sure that your Template Settings include showing decimal points, otherwise the voting results will be rounded and may appear visually incorrect.'

export const VoteNowMessageTooltip =
  'Enter your own text to replace a default "Please Vote Now" polling prompt.'

export const ParticipantRemoveVoteTooltip =
  'When turned ON, a vote can be removed by pressing the last button again.'

export const opacityTooltip = 'Enter value between 0 and 1.'

export const localStorageThemeIdentifier = 'darkMode'

export const CHART_TYPE = [
  { label: 'Bar', value: 'bar' },
  { label: 'Pie', value: 'pie' },
  { label: 'Column', value: 'column' },
]

export const CHART_VALUES = [
  { label: 'Percent', value: 'Percent' },
  { label: 'Absolute', value: 'Absolute' },
]

export const BULLET_FORMAT = [
  { label: 'Alphabetic', value: 'Alpha' },
  { label: 'Numeric', value: 'Numeric' },
  { label: 'Full Text', value: 'FullText' },
]

export const MESSAGE_POSITION = [
  { label: 'Top', value: 'Top' },
  { label: 'Bottom', value: 'Bottom' },
]

export const BACKGROUND_COLOR = [
  { label: 'Light Glass', value: 'LightGlass' },
  { label: 'Dark Glass', value: 'DarkGlass' },
  { label: 'Solid Black', value: 'SolidBlack' },
  { label: 'Solid White', value: 'SolidWhite' },
  { label: 'Transparent', value: 'Transparent' },
]

export const BACKGROUND_COLOR_CODE = {
  [BACKGROUND_COLOR[0].value]: 'rgba(0,0,0,0.3)',
  [BACKGROUND_COLOR[1].value]: 'rgba(0,0,0,0.8)',
  [BACKGROUND_COLOR[2].value]: 'rgba(0,0,0,1)',
  [BACKGROUND_COLOR[3].value]: 'rgba(255,255,255,1)',
  [BACKGROUND_COLOR[4].value]: `url('/transparent.png')`,
}
